import { useCallback, useEffect, useRef } from 'react';
export const useLatest = (instance)=>{
    const ref = useRef(instance);
    useEffect(()=>{
        ref.current = instance;
    }, [
        ref,
        instance
    ]);
    const refFree = useCallback((...args)=>ref.current(...args), [
        ref
    ]);
    return refFree;
};
export const useLatestRef = (args)=>{
    const ref = useRef(args);
    useEffect(()=>{
        ref.current = args;
    }, [
        args
    ]);
    return ref;
};
